/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSessionRequest = {
  sessionId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetSessionRequest$inboundSchema: z.ZodType<
  GetSessionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetSessionRequest$Outbound = {
  session_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetSessionRequest$outboundSchema: z.ZodType<
  GetSessionRequest$Outbound,
  z.ZodTypeDef,
  GetSessionRequest
> = z.object({
  sessionId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getSessionRequestToJSON(
  getSessionRequest: GetSessionRequest,
): string {
  return JSON.stringify(
    GetSessionRequest$outboundSchema.parse(getSessionRequest),
  );
}
export function getSessionRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSessionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSessionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSessionRequest' from JSON`,
  );
}
